import Constant from '../../const';
const axios = require('axios');

const postResendPCareReport = async params => {
  try {
    const { startDate, endDate } = params;
    const response = await axios.post(
      Constant.apiUrl
        .concat(`/pcare/report/resend`)
        .concat(`?startDate=${startDate}`)
        .concat(`&endDate=${endDate}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default postResendPCareReport;
